
export default (str) => {
  if (str && str.length > 21) {
    return str.substring(0, 21) + '...'
  }
  return str
}



// WEBPACK FOOTER //
// ./src/filters/maxLength_20.js